import script from "./Parameter_button.vue?vue&type=script&setup=true&lang=js"
export * from "./Parameter_button.vue?vue&type=script&setup=true&lang=js"

import "./Parameter_button.vue?vue&type=style&index=0&id=f9bec6dc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9bec6dc"]])

export default __exports__